import authenticate from "./authenticate";
const integration = async (_ref, user) => {
  let {
    clientId,
    clientSecret,
    endpoint,
    scope
  } = _ref;
  const config = {
    clientId,
    clientSecret,
    accessTokenUri: "".concat(endpoint, "/oauth/token"),
    redirectUri: "",
    username: user == null ? void 0 : user.username,
    password: user == null ? void 0 : user.password
  };
  return user ? authenticate({
    type: "owner",
    config,
    scope
  }) : authenticate({
    type: "clientCredentials",
    config,
    scope
  });
};
export default integration;